"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndexablePointEntityLineHitTester = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @internal
 * Hit tests a 2d line, assuming linear interpolation of size and excluding any cap.
 */
class IndexablePointEntityLineHitTester {
    /**
     * @returns true if the cssPosition is within the line. Does not consider line caps.
     */
    static hitTestEntity(entity, indexOfFirstPoint, cssPosition, updateArg) {
        const xOffset = entity.data.offsets.x;
        const yOffset = entity.data.offsets.y;
        const dataTransform = updateArg.interactionTransforms.dataToInteractiveArea;
        IndexablePointEntityLineHitTester.a.update(dataTransform.getVec3MultiplyX(updateArg.userTransform.forwardX(entity.data.getValue(indexOfFirstPoint, xOffset))), dataTransform.getVec3MultiplyY(updateArg.userTransform.forwardY(entity.data.getValue(indexOfFirstPoint, yOffset))));
        IndexablePointEntityLineHitTester.b.update(dataTransform.getVec3MultiplyX(updateArg.userTransform.forwardX(entity.data.getValue(indexOfFirstPoint + 1, xOffset))), dataTransform.getVec3MultiplyY(updateArg.userTransform.forwardY(entity.data.getValue(indexOfFirstPoint + 1, yOffset))));
        const ap = cssPosition.subtract(IndexablePointEntityLineHitTester.a, IndexablePointEntityLineHitTester.ap);
        const bp = cssPosition.subtract(IndexablePointEntityLineHitTester.b, IndexablePointEntityLineHitTester.bp);
        const ab = IndexablePointEntityLineHitTester.b.subtract(IndexablePointEntityLineHitTester.a, IndexablePointEntityLineHitTester.ab);
        const distanceFromLine = IndexablePointEntityLineHitTester.getPerpendicularDistanceToLineSegment(ab, bp, ap);
        const sizeOffset = entity.data.offsets.size;
        let cssLineWidthAtJoin;
        if (sizeOffset != null) {
            const sizeTransform = entity.graphicsSettings.pointSizeNormalizer.getSizeToPixelTransform();
            const sizeStart = sizeTransform.getVec2MultiplyX(entity.data.getValue(indexOfFirstPoint, sizeOffset));
            const sizeEnd = sizeTransform.getVec2MultiplyX(entity.data.getValue(indexOfFirstPoint + 1, sizeOffset));
            const segmentLength = ab.getMagnitude();
            const sizeScalingFactor = (sizeEnd - sizeStart) / segmentLength;
            const apLength = ap.getMagnitude();
            // the length of the segment ab up to the intersection of the line perpendicular to ab that passes through a
            const intersectionLength = Math.sqrt(apLength * apLength - distanceFromLine * distanceFromLine);
            cssLineWidthAtJoin = (sizeStart + sizeScalingFactor * intersectionLength) * 0.5;
        }
        else {
            cssLineWidthAtJoin = entity.graphicsSettings.pointDisplay.getPixelSize() * 0.5;
        }
        return distanceFromLine * updateArg.canvasDimensions.dpr <= cssLineWidthAtJoin;
    }
    static getPerpendicularDistanceToLineSegment(ab, bp, ap) {
        if (ab.dotProduct(bp) > 0) {
            // outside of line segment
            return Infinity;
        }
        if (ab.dotProduct(ap) < 0) {
            // outside of line segment
            return Infinity;
        }
        else {
            // is perpendicular to line segment
            const x1 = ab.getX();
            const y1 = ab.getY();
            return Math.abs(x1 * ap.getY() - y1 * ap.getX()) / Math.sqrt(x1 * x1 + y1 * y1);
        }
    }
}
exports.IndexablePointEntityLineHitTester = IndexablePointEntityLineHitTester;
// start point of line
IndexablePointEntityLineHitTester.a = rc_js_util_1.Vec2.f64.factory.createOneEmpty();
// end point of line
IndexablePointEntityLineHitTester.b = rc_js_util_1.Vec2.f64.factory.createOneEmpty();
// line vector
IndexablePointEntityLineHitTester.ab = rc_js_util_1.Vec2.f64.factory.createOneEmpty();
// line start to pointer
IndexablePointEntityLineHitTester.ap = rc_js_util_1.Vec2.f64.factory.createOneEmpty();
// line end to pointer
IndexablePointEntityLineHitTester.bp = rc_js_util_1.Vec2.f64.factory.createOneEmpty();
//# sourceMappingURL=indexable-point-entity-line-hit-tester.js.map